'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bid = require('./remote/bid');

var Bid = {
    postPlaceAbsenteeBid: _bid.BidRemote.postPlaceAbsenteeBid,
    postRetractBid: _bid.BidRemote.postRetractBid
};

exports.default = Bid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/bid.js
// module id = c28x
// module chunks = 60